import { hot } from 'react-hot-loader/root';
import PropTypes from 'prop-types';
import React from 'react';
import styled from '@emotion/styled';
import PageSection from '../design-system/PageSection';
import { HeadingArticle, HeadingPara, HeadingSub } from '../design-system/Headings';
import RichText, { FeatureHeadlineRenderer, SecondaryRenderer } from '../design-system/RichText';
import attributeContentPropTypes from '../proptypes/attribute-content';
import { UnorderedList, ListItem } from '../design-system/Lists';

const BackLink = styled.a`
    display: block;
    margin-bottom: 1rem;
    text-transform: uppercase;
`;

const Characteristics = ({ items }) => (
  <UnorderedList>
    {items.map(item => (<ListItem key={item} className="ss_color--secondary ss_tt--uppercase">{item}</ListItem>))}
  </UnorderedList>
);
Characteristics.propTypes = {
  items: PropTypes.arrayOf(PropTypes.string).isRequired,
};

const AttributeContentSection = ({
  title,
  conditionalDescription,
  theScience,
  lowCharacteristics,
  highCharacteristics,
  backLink: {
    text: backLinkText,
    path: backLinkPath,
  },
  phrases: {
    lowCharacteristicTitle,
    highCharacteristicTitle,
    theScienceTitle,
  },
}) => (
  <PageSection>
    <div className="row justify-content-md-center">
      <div className="col-12 col-lg-9" data-testid="header">
        {backLinkPath && backLinkText && <BackLink href={backLinkPath}>{`← ${backLinkText}`}</BackLink>}
        <HeadingArticle el="h1">{title}</HeadingArticle>
        {conditionalDescription && (
          <RichText content={conditionalDescription} paragraphRenderer={FeatureHeadlineRenderer} />
        )}
        <HeadingPara el="h2">{theScienceTitle}</HeadingPara>
        <RichText content={theScience} paragraphRenderer={SecondaryRenderer} />
      </div>
    </div>
    <div className="row justify-content-md-center">
      {highCharacteristics.length > 0 && (
        <div className="col-12 col-lg-9" data-testid="high-traits">
          <HeadingSub el="h3">{highCharacteristicTitle}</HeadingSub>
          <Characteristics items={highCharacteristics} />
        </div>
      )}
      {lowCharacteristics.length > 0 && (
        <div className="col-12 col-lg-9" data-testid="low-traits">
          <HeadingSub el="h3">{lowCharacteristicTitle}</HeadingSub>
          <Characteristics items={lowCharacteristics} />
        </div>
      )}
    </div>
  </PageSection>
);

AttributeContentSection.propTypes = {
  ...attributeContentPropTypes.isRequired,
  backLink: PropTypes.shape({
    text: PropTypes.string.isRequired,
    path: PropTypes.string.isRequired,
  }).isRequired,
};

export default hot(AttributeContentSection);
